/**
 * CoinPill — the coin balance chip in the header. Uses the real bundled coin asset.
 * Display-only for now (the economy is not yet wired).
 */

import { Text, View } from 'react-native';
import { Image } from 'expo-image';
import { WEB_IMAGE_ALT_DECORATIVE } from '../../../src/shared/helpers/imageWebAlt.helper';
import { COIN_IMAGE_SOURCE } from './characterCustomizer.assets';
import { coinPillStyles as styles } from './CoinPill.styles';

interface CoinPillProps {
  coins: number;
}

export function CoinPill({ coins }: CoinPillProps) {
  return (
    <View style={styles.pill} accessibilityRole="text" accessibilityLabel={`${coins} coins`}>
      <Image source={COIN_IMAGE_SOURCE} style={styles.coin} contentFit="contain" alt={WEB_IMAGE_ALT_DECORATIVE} />
      <Text style={styles.amount}>{coins.toLocaleString()}</Text>
    </View>
  );
}
